import reducer from './reducer';
import middleware from './middleware';
import enhancer from './enhancer';

import createInstaller from './util/create-installer';

export default createInstaller({ reducer: reducer, middleware: middleware, enhancer: enhancer });


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-little-router/es/install.js
// module id = 83
// module chunks = 0